var _circle, _path, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataBought(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 21.4026C6.875 19.2914 6.875 18.2357 7.16696 17.3856C7.70633 15.8151 8.94012 14.5813 10.5106 14.042C11.3607 13.75 12.4164 13.75 14.5276 13.75H15.625C17.3176 13.75 18.1638 13.75 18.8663 13.8971C21.5596 14.4611 23.6639 16.5654 24.2279 19.2587C24.375 19.9612 24.375 20.8074 24.375 22.5C24.375 24.1926 24.375 25.0388 24.2279 25.7413C23.6639 28.4346 21.5596 30.5389 18.8663 31.1029C18.1638 31.25 17.3176 31.25 15.625 31.25C13.9324 31.25 13.0862 31.25 12.3837 31.1029C9.69041 30.5389 7.58611 28.4346 7.0221 25.7413C6.875 25.0388 6.875 24.1926 6.875 22.5V21.4026Z",
    fill: "#E5B910"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8574,
    cy: 20.4863,
    r: 2.4746,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M32.3634 10.6265C32.2357 10.3956 32.0352 10.2111 31.7983 10.1088C31.6342 10.0435 31.1418 9.94227 31.1334 9.94227C30.5953 9.84005 29.7206 9.78516 28.7544 9.78516C27.834 9.78516 26.9957 9.84005 26.4492 9.92334C26.4399 9.9328 25.83 10.035 25.6201 10.1458C25.2369 10.3492 25 10.7467 25 11.1726V11.2096C25.0093 11.4869 25.2462 12.0689 25.2555 12.0689C25.6565 13.0494 26.9043 14.983 27.7342 15.7591C27.7342 15.7591 27.9478 15.9787 28.0802 16.0733C28.2714 16.2219 28.5083 16.2957 28.7461 16.2957C29.01 16.2957 29.2552 16.2125 29.4567 16.0554C29.493 16.0184 29.6478 15.8793 29.7756 15.7506C30.5767 14.9915 31.8897 13.0125 32.2897 11.9771C32.3541 11.82 32.4912 11.4216 32.4996 11.2096C32.4996 11.0061 32.4548 10.8111 32.3634 10.6265Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataBought);
export default __webpack_public_path__ + "static/media/data-bought.22a112e7227ffd02f240fe5aec88745c.svg";
export { ForwardRef as ReactComponent };